<template>
  <el-dialog
    :visible="visible"
    title="Defina uma nova senha"
    width="420px"
    center
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <p>Sua senha atual foi gerada automaticamente. Para continuar, defina uma senha pessoal.</p>
    <el-form ref="form" :model="form" :rules="rules" label-position="top" @submit.native.prevent>
      <el-form-item label="Nova senha" prop="password">
        <el-input v-model="form.password" type="password" maxlength="20" show-password></el-input>
      </el-form-item>
      <el-form-item label="Confirme a nova senha" prop="confirm">
        <el-input
          v-model="form.confirm"
          type="password"
          maxlength="20"
          show-password
          @keyup.enter.native="save"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" :loading="saving" @click="save">Salvar nova senha</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { UserService } from "@/services/users/user.services";

// Primeiro acesso ou senha redefinida pelo admin (`alterarsenha`): bloqueia o uso até trocar.
export default {
  name: "ForcePasswordChange",
  data() {
    const sameAsPassword = (rule, value, callback) =>
      value === this.form.password ? callback() : callback(new Error("As senhas não conferem"));
    return {
      visible: false,
      saving: false,
      form: {
        password: "",
        confirm: "",
      },
      rules: {
        password: [
          { required: true, message: "Informe a nova senha", trigger: "blur" },
          { min: 8, message: "A senha deve ter ao menos 8 caracteres", trigger: "blur" },
        ],
        confirm: [{ validator: sameAsPassword, trigger: "blur" }],
      },
    };
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.saving = true;
        UserService.changeOwnPassword(this.form.password)
          .then(() => {
            this.visible = false;
            this.$message({ type: "success", message: "Senha alterada com sucesso!" });
          })
          .catch((error) => this.$message({ type: "error", message: error }))
          .finally(() => (this.saving = false));
      });
    },
  },
  mounted() {
    UserService.me()
      .then((user) => {
        this.visible = user.changePassword === true;
      })
      .catch(() => {});
  },
};
</script>
